import { render, staticRenderFns } from "./SplashScaffold.vue?vue&type=template&id=0479a5a6&"
import script from "./SplashScaffold.vue?vue&type=script&lang=ts&"
export * from "./SplashScaffold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports